'use client';

import type { FC } from 'react';
import type { StaticImageData } from 'next/image';
import { Button } from './ui';
import { cn } from '../utils/cn';

interface GameTileProps {
  title: string;
  description: string;
  cta: string;
  hero: StaticImageData;
  accent?: string;
  badge?: string | null;
  onClick?: () => void;
  priority?: boolean;
}

export const GameTile: FC<GameTileProps> = ({ title, description, cta, hero, accent, badge = null, onClick, priority = false }) => {
  const active = badge === null && onClick !== undefined;
  return (
    <div
      onClick={active ? onClick : undefined}
      style={{
        position: 'relative',
        height: 150,
        borderRadius: 22,
        overflow: 'hidden',
        border: '1px solid rgba(255,255,255,0.08)',
        cursor: active ? 'pointer' : 'default',
        opacity: badge === null ? 1 : 0.75,
      }}
    >
      <img
        src={hero.src}
        alt={title}
        width={hero.width}
        height={hero.height}
        fetchPriority={priority ? 'high' : undefined}
        decoding="async"
        style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }}
      />
      <div
        style={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(90deg, rgba(7,7,12,0.94) 0%, rgba(7,7,12,0.62) 46%, transparent 100%)',
        }}
      />
      <div
        style={{
          position: 'absolute',
          left: 18,
          top: 0,
          bottom: 0,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          paddingTop: 12,
          paddingBottom: 12,
          maxWidth: '66%',
        }}
      >
        {badge !== null && (
          <span
            className="border border-price/35 bg-price/12 text-price"
            style={{
              alignSelf: 'flex-start',
              marginBottom: 8,
              fontSize: 10,
              fontWeight: 700,
              padding: '2px 8px',
              borderRadius: 9999,
            }}
          >
            {badge}
          </span>
        )}
        <div className="text-white" style={{ fontSize: 22, fontWeight: 800, letterSpacing: '-0.01em' }}>{title}</div>
        <div className="text-white" style={{ fontSize: 13, marginTop: 4 }}>{description}</div>
        {badge === null && (
          <Button as="span" size="m" className={cn('mt-auto self-start px-[18px] text-[13px] font-bold', accent)}>
            {cta}
          </Button>
        )}
      </div>
    </div>
  );
};
